module.exports = __webpack_public_path__ + "img/mapp@2x.00b740a8.png";